document.addEventListener("alpine:init", () => {
  Alpine.data(
    "translationsController",
    (translations, language, overrides) => ({
      translations: translations,
      language: language,
      overrides: overrides,

      vals() {
        let defaults = translations["en"];
        if (language in translations) {
          defaults = translations[language];
        }

        let descriptions = translations["descriptions"];

        return Array.from(Object.keys(defaults), (t) => {
          return {
            key: t,
            default: defaults[t],
            override: overrides ? overrides[t] : "",
            description: descriptions ? descriptions[t] : t,
          };
        });
      },
    }),
  );
});
